module.exports = __webpack_public_path__ + "img/8.eedc4b57.png";